export default __webpack_public_path__ + "static/media/logoSimple.1d0c2166.png";